/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from "react";
import { styled } from "styled-components";
import * as Yup from "yup";
import { Box } from "@mui/material";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import { SERVICES } from "../../components/Layout/Services";
import Button from "../../components/Layout/Button";
import BankTable from "../../components/Layout/Table/BankTable";
import BankModal from "../../components/Layout/Modal/BankModal";
import { get, post, put } from "../../components/Layout/ApiHandler/apihandler";
import OldInputField from "../../components/Layout/InputField";
import InputField from "../../components/Layout/fieldInput/InputField";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading";
import {
  OuterContainerStyles,
  SearchContainer,
  Title,
} from "../../components/Layout/Typography";
import Loader from "../../components/Loader/Loader";
import { AlertStatus } from "../../contants";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";
import NoData from "../../components/NoData";
import Alert from "../../components/Alert/Alert";
import AutoCompleteDropdown from "../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";
import BankTableForDrawnBank from "../../components/Layout/Table/BankTableForDrawnBank";

const NoteContainer = styled.div`
  padding: 0 24px 24px 24px;
`;
const NoteText = styled.p`
  color: #6d6d6d;
  font-size: 14px;
  font-weight: 700;
  margin: 0 0;
`;
const NoteListItem = styled.li`
  color: #6d6d6d;
  font-size: 14px;
  font-weight: 400;
  margin: 0 0;
`;

const BankDetailsSchema = Yup.object().shape({
  branchName: Yup.string().required("Branch is required"),
  ifscCode: Yup.string().required("IFSC Code is required"),
  accountNumber: Yup.number().required("Account Number is required"),
  defaultForCa: Yup.boolean().required("You must accept defaultForCa"),
});

const getOptions = (options, key) =>
  options?.map((opt) => ({
    ...opt,
    value: opt[key],
  }));

function DrawnBankDetails() {
  const TITLE = "Drawn Bank Details - BSG ContributionAdmin";
  const [bankData, setBankData] = useState({});
  const [banksData, setBanksData] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState("");
  const [banksIds, setBanksIds] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bankBranchData, setbankBranchData] = useState([]);
  const [bankIndId, setBankIndId] = useState("");
  const [branchIndId, setBranchIndId] = useState("");
  const [searchText, setSearchText] = useState("");
  const [individualBankData, setIndividualBankData] = useState([]);
  const [bankBranchesDataArray, setBankBranchesDataArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useContext(ToastAlertContext);
  const [openAlert, setOpenAlert] = useState(false);
  const [intitialBankValues, setInitialBankValues] = useState({});
  const [branchName, setBranchName] = useState("");
  const [ifscCode, setIfsc] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [otherBank, setOtherBank] = useState("");
  const [selectedBankName, setSelectedBankName] = useState("");
  const [defaultContribution, setDefaultContribution] = useState("");
  const [bankName, setBankName] = useState("");

  const handleAlertClose = () => {
    setOpenAlert(false);
  };
  const handleBankSelect = (bankId) => {
    setSelectedBankId(bankId);
  };
  const handleBranchName = (value) => {
    setBranchName(value);
  };
  const handleIfsc = (value) => {
    setIfsc(value);
  };

  const handleAccountNumber = (value) => {
    setAccountNumber(value);
  };
  const handleOtherBanks = (value) => {
    setOtherBank(value);
  };
  const handleDefaultContributionChange = (event) => {
    const { value } = event.target;
    setDefaultContribution(value);
  };

  const fetchBankData = async () => {
    try {
      const url = `${SERVICES.GET_BSG_BANKS}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        setBanksData(data.data);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const handleSubmit = async () => {
    if (bankName.trim() === "") {
      return;
    }
    const url = SERVICES.GET_BSG_BANKS;
    const data = {
      bankName: bankName.trim(),
    };

    try {
      const response = await post(url, data);
      if (response.ok) {
        const data = await response.json();
        await fetchBankData();
        toast.show("Bank Details Added Successfully", AlertStatus.SUCCESS);
        setBankName("");
      }
      if (response.status === 500) {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
      }
    } catch (error) {
      toast.show(error.message, AlertStatus.SUCCESS);
      Sentry.captureException(error);
    }
  };

  const handleInputChange = (event) => {
    setSearchText(event.target.value);
  };
  const handleDeleteAlert = (bankId, branchId) => {
    setBankIndId(bankId);
    setBranchIndId(branchId);
    setOpenAlert(true);
  };

  useEffect(() => {
    fetchBankData();
  }, []);

  const validateBankDetails = () => {
    if (!selectedBankId) {
      toast.show("Please Select Bank", AlertStatus.ERROR);
      return false;
    }
    if (!branchName) {
      toast.show("Please Enter Branch Name", AlertStatus.ERROR);
      return false;
    }
    if (!ifscCode) {
      toast.show("Please Enter IFSC Code", AlertStatus.ERROR);
      return false;
    }
    if (!accountNumber) {
      toast.show("Please Enter Account Number", AlertStatus.ERROR);
      return false;
    }
    if (selectedBankName === "Other Bank" && !otherBank) {
      toast.show("Please Enter Other Bank", AlertStatus.ERROR);
      return false;
    }
    return true;
  };
  const resetForm = () => {
    setSelectedBankId("");
    setBranchName("");
    setIfsc("");
    setAccountNumber("");
    setDefaultContribution("");
    setSelectedBankName("");
  };

  const handleSubmitForm = async () => {
    if (!validateBankDetails()) {
      return;
    }
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${selectedBankId}/branches`;
      const data = {
        branchName,
        ifscCode,
        accountNumber,
        defaultForCa: defaultContribution || false,
      };
      const response = await post(url, data);
      if (response.ok) {
        toast.show("Bank Details Added Successfully", AlertStatus.SUCCESS);
        resetForm();
      } else {
        toast.show("Something Went Wrong", AlertStatus.ERROR);
        console.error("Failed to submit the form");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleModalSubmit = async (values) => {
    try {
      const url = `${SERVICES.BANKS_DETAILS}/${bankIndId}/branches/${branchIndId}`;
      const response = await put(url, values);
      if (response.ok) {
        toast.show("Bank Details Updated Successfully", AlertStatus.SUCCESS);
        closeModal();
      } else {
        console.error("Failed to submit the form");
      }
    } catch (error) {
      toast.show(error.message || "Something Went Wrong", AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  const handleSearch = () => {
    const filteredData = banksData.filter((item) =>
      item.bankName.toLowerCase().includes(searchText.toLowerCase()),
    );

    const updatedTableData = filteredData.map((item, index) => ({
      id: item.id,
      column1: index + 1,
      column2: item?.bankName,
    }));

    setTableData(updatedTableData);
  };

  useEffect(() => {
    if (banksData) {
      console.log("line 403", banksData);
      const filteredData = banksData.filter(
        (item) => item.bankName !== "Other Bank",
      );
      const updatedTableData = filteredData.map((item, index) => {
        return {
          id: item.id,
          column1: index + 1,
          column2: item?.bankName,
        };
      });
      setTableData(updatedTableData);
    }
  }, [banksData]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const tableHeaders = [
    "S. No.",
    "BSG Bank Name",
    // "Branch",
    // "IFSC Code",
    // "A/C No.",
  ];
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Drawn Bank Details" />
      <OuterContainerStyles>
        <Title>Bank Details</Title>
        <SearchContainer>
          <OldInputField
            onChange={(e) => setBankName(e.target.value)}
            placeholder="Bank Name"
            customvalue={bankName}
          />
          <Button onClick={handleSubmit}>+ Add Bank</Button>
        </SearchContainer>
      </OuterContainerStyles>
      <OuterContainerStyles>
        <Title>Existing Bank</Title>
        <SearchContainer>
          <OldInputField
            onChange={handleInputChange}
            placeholder="Bank Name"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
          <Button onClick={handleSearch}>Search</Button>
          <Btn onClick={() => fetchBankData()}>View All</Btn>
        </SearchContainer>
        {tableData?.length ? (
          // <BankTable data={tableData} headers={tableHeaders} />
          <BankTableForDrawnBank data={tableData} headers={tableHeaders} />
        ) : (
          !tableData?.length && isLoading === false && <NoData />
        )}
      </OuterContainerStyles>
      {/* <OuterContainerStyles marginTop="24px">
        <OuterCard>
          <OuterCardHeading fontSize="18px" fontWeight="500">
            BSG Bank Details
          </OuterCardHeading>
          <FieldsDiv>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.bankName}
              options={getOptions(banksData, "id")}
              label="Select Bank"
              value={selectedBankId}
              onChange={(selectedValue) => {
                handleBankSelect(selectedValue?.value);
                setSelectedBankName(selectedValue?.bankName);
              }}
              inputProps={{
                required: true,
              }}
              useHiddenInput
              style={{ width: "350px" }}
            />
            <InputField
              label="Branch"
              required
              value={branchName}
              onChange={(event) => {
                const { value } = event.target;
                handleBranchName(value);
              }}
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <InputField
              label="IFSC"
              required
              value={ifscCode}
              onChange={(event) => {
                const { value } = event.target;
                handleIfsc(value);
              }}
              style={{ width: "350px" }}
            />
            <InputField
              label="Account Number"
              required
              value={accountNumber}
              onChange={(event) => {
                const { value } = event.target;
                handleAccountNumber(value);
              }}
              style={{ width: "350px" }}
            />
          </FieldsDiv>
          <FieldsDiv>
            <InputField
              label="Other Bank"
              onChange={(event) => {
                const { value } = event.target;
                handleOtherBanks(value);
              }}
              required={selectedBankName === "Other Bank"}
              style={{ width: "350px" }}
            />
            <Box sx={{ width: "350px" }} />
          </FieldsDiv>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
              width: "100%",
            }}
          >
            <div style={{ flex: 1 }} />
            <Button
              cancel
              type="button"
              onClick={() => {
                resetForm();
              }}
            >
              Cancel
            </Button>
            <Button type="button" onClick={handleSubmitForm}>
              Submit
            </Button>
          </div>
        </OuterCard>
      </OuterContainerStyles> */}
      <BankModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSubmit={handleModalSubmit}
        initialValues={{
          branchName: intitialBankValues.branchName,
          ifscCode: intitialBankValues.ifscCode,
          accountNumber: intitialBankValues.accountNumber,
          defaultForCa: intitialBankValues.defaultForCa,
        }}
      />
      <Alert
        open={openAlert}
        onClose={handleAlertClose}
        // onSubmit={() => handleDeleteBank(bankIndId, branchIndId)}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default DrawnBankDetails;

const Btn = styled.button`
  border: none;
  background-color: transparent;
  color: #00adf8;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
`;

const OuterCard = styled.div`
  display: flex;
  padding: 12px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid #c5c5d1;
  background: #f5f5f5;
`;

const OuterCardHeading = styled.p`
  margin: 0;
  color: #000;
  //   font-family: Noto Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const FieldsDiv = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 146px;
  align-self: stretch;
`;
